class InlineIcons extends HTMLElement {
  constructor() {
    super();
    this.icons = window.icons;
  }

  connectedCallback() {
    this.iconName = this.dataset.icon;
    this.innerHTML = `${this.getSVGIcon(this.iconName)}`;
  }

  getSVGIcon(iconName) {
    const icon = this.icons.find((image) => image.name.toLowerCase() === iconName.toLowerCase());

    if (icon) {
      // eslint-disable-next-line max-len
      return `<img src="${icon.image}" alt="${iconName}" class="inline quick-icon" />`;
    }
    return null;
  }
}

customElements.define('domaine-inline-icons', InlineIcons);
